module.exports = {
    loading:'ဆောင်ရွက်နေပါသည်',
    logout:'ထွက်မည်',
    logoutDesc:'ထွက်မှာ သေချာပါသလား',
    check:'စစ်ဆေးသည်',
    ansTitle1:'သင်၏ အဖြေ မှန်ကန်မှု ရှိပါသည်',
    ansTitle2:'သင်သည် အောက်ပါ သေတ္တာပုံးကို ရရှိသွားပါပြီ',
    ansTitle3:'သင်၏ အဖြေ မှားယွင်းနေပါသည်',
    congratulations:'ဂုဏ်ယူပါတယ်။!',
    ladingpageTips:'(မေလ ၁၀ ရက်နေ့မှ ဇွန်လ ၁၀ ရက်နေ့အထိ အခမဲ့)',
    ladingpageTips2:'ပထမဆုံးအကြိမ်အသုံးပြုသူများအတွက်သာ',
    Daily:'နေ့စဉ်',
    dailyM:'၁၄၉ကျပ်',
    Weekly:'၃ ရက်',
    weeklyM:'၅၉၉ကျပ်',
    Monthly:'လစဉ်',
    monthlyM:'၁၉၉၉ကျပ်',
    subscribeNow:'စာရင်းသွင်းလိုက်ပါ',
    Copyright:'မူပိုင်ခွင့် © ဝိုးဘောက်စ် ၂၀၂၃',
    CopySucceeded:'အောင်မြင်စွာ ကော်ပီ ကူးပြီးပါပြီ',
    play:'ရွေးချယ်ပါ',
    myAccount:'ပုဂ္ဂိုလ်ရေးအချက်အလက်',
    profile:'ပရိုဖိုင်',
    FAQs:'မေးလေ့မေးထရှိသော မေးခွန်းများ',
    FAQ:'သိလိုရာများ',
    TC:'စည်းကမ်းများ',
    language:'ဘာသာစကား',
    Submit:'တင်ပြသည်',
    change:'ပြောင်းလဲပါ',
    English:'အင်္ဂလိပ်',
    showMore:'ထပ်မံ ကြည့်ရှုရန်',
    Login:'လော့ဂ်အင်ဝင်သည်',
    Logout:'လော့ဂ်အောက်ထွက်သည်',
    getCode:'OTP ပို့ရန်',
    phoneNumber:'ဖုန်းနံပါတ်',
    enderNumber:'ဖုန်းနံပါတ်ထည့်သွင်းပါ',
    Name:'အသုံးပြုသူအမည်',
    address:'လိပ်စာ',
    phone:'ဖုန်း',
    Prize:'ဆုများ',
    referral:'ရည်ညွှန်းခြင်း',
    winnerList:'အနိုင်ရသူများစာရင်း',
    Date:'ရက်စွဲ',
    Phone:'ဖုန်းနံပါတ်',
    Save:'သိမ်းဆည်းသည်',
    cancel:'ပယ်ဖျက်သည်',
    Confirm:'အတည်ပြုသည်',
    goBack:'အနောက်သို့ ပြန်သွားမည်',
    No:'မလုပ်ပါ',
    OK:'အိုကေ',
    Yes:'လုပ်မည်',
    UNSUBSCRIBE:'စာရင်းသွင်းခြင်းမှ ပယ်ဖျက်သည်',
    noMore:'မပိုသော',
    more:'ပိုသော',
    des2:'သင် စာရင်းသွင်းခြင်းမှ ပယ်ဖျက်မည်မှာ သေချာပြီးလား?',
    boxes:'boxes',
    box:'box',
    referralTips1:"ဆုရရှိဖို့အတွက် အသုံးပြုသူ အသစ်ကို ဖိတ်ခေါ်ပါ။ ဖိတ်ခေါ်ခံရသူက အောင်မြင်စွာ စာရင်းသွင်းနောက် သင်သည် ညဏ်စမ်းပဟေဠိ မေးခွန်း ၅ခုကို လက်ခံရရှိပါလိမ့်မည်။ ဖိတ်ခေါ်ခံရသူက ဉာဏ်စမ်းပဟေဠိ မေးခွန်း ၁၀ခု ရရှိပါလိမ့်မည်။",
    memberGetMember:'သူငယ်ချင်းကို ရည်ညွှန်းမည်',
    referralTips2:'ဤအရာသည် သင်၏ ရည်ညွှန်းအိုင်ဒီ ဖြစ်ပါသည်',
    referralTips3:'ဤအရာသည် သင်၏ သူငယ်ချင်း ရည်ညွှန်းအိုင်ဒီ ဖြစ်ပါသည်',
    Status:'အခြေအနေ',
    noFound:'ဘုရားရေ <br />မည်သည့်ရလဒ်ကိုမျှ ရှာဖွေမတွေ့ရှိပါ',
    cgtips1:'ဆုထူးကြီးတွေကို ကံထူးလိုက်ပါ!!!',
    cgtips2:'တစ်ရက်လျှင် ၁၄၉ကျပ်သာ,<br />စာရင်းသွင်းရန် ကျေးဇူးပြု၍ အိုကေ ကို နှိပ်ပါ',
    cgtips2W:'အပတ်စဉ် ၅၉၉ကျပ်သာ,<br / > စာရင်းသွင်းရန် ကျေးဇူးပြု၍ အိုကေကိုနှိပ်ပါ.',
    cgtips2M:'လစဉ်၁၉၉၉ကျပ်သာ,<br /> စာရင်းသွင်းရန် ကျေးဇူးပြု၍ အိုကေကိုနှိပ်ပါ.',
    indexbutton1:'ကျပန်း ရွေးချယ်ပါ',
    indexbutton2:'ကိုးကြိမ် ရွေးချယ်ပါ',
    indexbutton3:'နောက်ထပ် ပုံးများ ဝယ်ယူမည်',
    landFont1:'ဖုန်းနံပါတ် ထည့်သွင်းပါ',
    landFont2:'ပက်ကေ့ချ် ရွေးချယ်ပါ',
    landingFont:'စာရင်းသွင်းခကို ပင်မလက်ကျန်ငွေမှ ကောက်ခံပါမည်။',
    optTips:'သင်စာရင်းသွင်းထားပြီးဖြစ်သည်၊ အကောင့်ဝင်ကုဒ်ကိုရယူရန် ကျေးဇူးပြု၍ <span class="app-en">OK</span> ကိုနှိပ်ပါ။',
    landingContent:'<div class="ac">ဝန်ဆောင်မှုဆိုင်ရာအဖိုးအခကောက်ခံခြင်းဆိုင်ရာစည်းကမ်းချက်များ</div><br />၁။စာရင်းပေးသုံးစွဲ မှုရယူထားသော ဝန်ဆောင်မှု၏တရားဝင်အသုံးပြုနိုင်သည့်ကာလမှာ ၃၆၅ ရက်ဖြစ်ပြီး နေ့စဉ်/ အပတ်စဉ်/လစဉ်အရစ်ကျငွေပေးချေမှုစနစ်ဖြင့် ရွေးချယ်ထားသောဝန်ဆောင်မှုပေါ်မူတည်ပြီး အသုံးပြုနိုင်မှာဖြစ်ပါတယ်။<br/><br />၂။အသုံးပြုမှုအတွက်အဖိုးအခကို ကောက်ခံသည့်အကြိမ်ရေမှာ တစ်ကြိမ် (ဥပမာသက်တမ်းတိုးမှုမပါသော သို့မဟုတ် နေ့စဉ်ကောက်ခံမှုမရှိသော) သို့မဟုတ် အစဉ်အဆက်လိုက် (ဥပမာ-အပတ်အလိုက်/ လအလိုက်ကောက်ခံမှုရှိသည့်၃၆၅ရက် အသုံးပြုနိုင်သည့်ဝန်ဆောင်မှု) ဖြစ်နိုင်ပါသည်။<br /><br />၃။အကယ်၍ အက်တမ်၏ မိတ်ဖက်ကုမ္မဏီများမှ ဝန်ဆောင်မှုတွင်အခမဲ့ စမ်းသပ်အသုံးပြုကာလပါရှိပါက အသုံးပြုသူသည်သတ်မှတ်ထားသည့် အခမဲ့စမ်းသပ်အသုံးပြုကာလ အတွက်သာဝန်ဆောင်မှုကိုအခမဲ့ အသုံးပြုနိုင်မည်ဖြစ်သည်။ ထိုအခမဲ့စမ်းသပ်ကာလပြီးဆုံးပါက သင်၏ မိုဘိုင်းလက်ကျန်ငွေထဲမှဝန်ဆောင်မှုအတွက် နေ့စဉ်/ အပတ်စဉ်/ လစဉ်ကျသင့်ငွေကို ကောက်ခံမည်ဖြစ်သည်။<br /><br />၄။သုံးစွဲသူဘက်မှ ရယူထားသည့်ဝန်ဆောင်မှုအသုံးပြုနေခြင်းကို ပယ်ဖျက်နိုင်ပါတယ်။ ထိုသို့စာရင်းပယ်ဖျက်ရန် အကြောင်းကြားမှုလက်ခံရရှိပြီးနောက် ကျွန်ုပ်တို့ အက်တမ်အနေဖြင့် ဝန်ဆောင်မှုအသုံးပြုခကို ကောက်ခံတော့မည်မဟုတ်ပါ။<br /><br />၅။ဝန်ဆောင်မှုကိုရယူသည်ဟု အတည်ပြုမှုသည် ဤဝန်ဆောင်မှုဆိုင်ရာ အဖိုးအခကောက်ခံခြင်း ဆိုင်ရာစည်းကမ်းချက်များကို ကိုယ်တိုင်အသိအမှတ်ပြု လက်ခံကြောင်းအတည်ပြုပါသည်။ ဝန်ဆောင်မှုကိုလက်ခံပြီးသည်နှင့်တစ်ပြိုင်နက်စည်းမျဉ်းစည်းကမ်းချက်များကိုလက်ခံပြီး ဖြစ်ပါသည်။',
  Invitation_Link:'သင်၏ ဖိတ်ကြားချက်လင့်ခ်ဖြစ်သည်',
  Copy:'ကူးယူရန်',
  Invitation_Count:'ဖိတ်ခေါ်ပြီးသားလူအရေအတွက်',
  start:'စတင်',
  BuyMore:'အပိုမေးခွန်းယူမယ်',
  buytitle:'မေးခွန်းထပ်မံဝယ်ယူရန်',
  buytitle2:'နောက်ထပ်မေးခွန်းများကို ရယူရန်',
  buyContent:'စိန်ခေါ် မှုများကိုဆက်လက်လုပ်ဆောင်လိုပါသလား။ သေတ္တာများကိုဖွင့်ပြီး ဆုမဲများကိုကံထူးဖို့  ၉၉ ကျပ်ဖြင့် မေးခွန်းများကိုဝယ်ယူကြမယ် ။ ',
  enterOtp:'တစ်ခါသုံး စကားဝှက်ထည့်ပါ ',
  enterOtpContent:'သင့်ဖုန်းသို့ တစ်ခါသုံး စကားဝှက်တစ်ခု ပေးပို့ပြီးဖြစ်သည်။ သင်၏ဝယ်ယူမှုကိုအတည်ပြုရန် အောက်တွင်ထည့်သွင်းပါ။',
  ResendTips:'တစ်ခါသုံးစကားဝှက်ရရှိပါသလား။ ',
  ResendOTP:'စကားဝှက်ပြန်ပို့မည်',
  pleaseWait:'ကျေးဇူးပြုပြီးခဏစောင့်ပါ',
  buyBtn:'မေးခွန်း ၁ ခု - ၉၉ ကျပ်',
  otpSms:'သင်၏ Wowbox အတည်ပြုကုဒ် သည် ',
  optSms2:" ဖြစ်သည်။ မည်သူကိုမှ မမျှဝေပါနှင့်။",
  ques_left:"လက်ကျန်မေးခွန်းများ",
  re_sub_tip:'သင်ဝန်ဆောင်မှုကို ပယ်ဖျက်ပြီးပြီလား ?',
  subscribe:'စာရင်းသွင်းပါ။',
  login_tip_2:'၇ရက်စာ အခမဲ့အပြင် သတ်တမ်းတိုး၀ယ်ယူမှုတိုင်းအတွက် အက်တမ်စတားပွိုင့် ၃၀ကိုရယူလိုက်ပါ',
  sharePanelTitle:'သူငယ်ချင်းများထံ မျှဝေပါ',
  sharePanelTips:'အောက်ပါ platform များထဲမှ တစ်ခုကိုရွေးပြီး invite link ကို တိုက်ရိုက်ပို့လိုက်ပါ။',
  shareMore:'အခြား App များသို့ မျှဝေမယ်',
  claimRewardMessage:'ဝန်ဆောင်မှုကို အောင်မြင်စွာ စတင်အသုံးပြုသည့်အတွက် 30MB ဒေတာလက်ဆောင်ကို ရရှိထားပါသည်။',
  claimNow:'ယခုပင် ရယူပါ',
  claimRewardSuccess:'30MB ဒေတာလက်ဆောင်ကို အောင်မြင်စွာ ရယူပြီးပါပြီ။',
  claimClose:'ဆုလာဘ်ပိတ်ရန်',
  claimRewardListTitle:'ဒေတာလက်ဆောင်',
  claimRewardExpiry:'သက်တမ်းကုန်ဆုံးချိန်',
  claimRewardAmount:'ဒေတာ',
  claimRewardAction:'ရယူမည်',
  claimRewardEmpty:'ရယူနိုင်သော ဒေတာလက်ဆောင် မရှိသေးပါ။',
  homeLetsCheck:'အဖြေ စစ်မယ်',
  homeQuestionsLeft:'ကျန်မေးခွန်းများ:',
  homeMoreQuestions:'မေးခွန်းထပ်ယူရန်',
  homeLuckyDescription:'ကံကောင်းသောသေတ္တာကို ရွေးပြီး',
  homeAmazingRewards:'ဆုလက်ဆောင်များ ရယူလိုက်ပါ။',
  homePick:'ရွေးမယ်',
  homeRandomPick:'ကျပန်းရွေးမယ်',
  homeGiftBoxesLeft:'ကျန်သေတ္တာများ:',
  homeViewAllPrizes:'ဆုအားလုံးကြည့်ရန်',
  homeWinners:'ဆုရသူများ',
  homeProfile:'ပရိုဖိုင်',
  homeLuckyBoxes:'ကံစမ်းသေတ္တာများ',
  homeLuckyAvailable:'ကံစမ်းသေတ္တာ ရှိသည်!',
  homeTabNavigation:'ပင်မစာမျက်နှာ လမ်းညွှန်',
  prizesTitle:'ဆုများ',
  prizesBack:'နောက်သို့',
  prizesIntroBefore:'',
  prizesLuckyBoxes:'ကံစမ်းသေတ္တာများကို',
  prizesIntroMiddle:' ဖွင့်ပြီး အောက်ပါ ',
  prizesRewards:'ဆုများကို ရယူပါ။',
  prizesCash300000:'ငွေသား 300,000 ကျပ်',
  prizesGoldRing:'ရွှေလက်စွပ်',
  prizesSmartPhone:'စမတ်ဖုန်း',
  prizesCash100000:'ငွေသား 100,000 ကျပ်',
  prizesTopUp20000:'ဖုန်းဘေလ် 20,000 ကျပ်',
  prizesTopUp10000:'ဖုန်းဘေလ် 10,000 ကျပ်',
  prizesData500MB:'ဒေတာ 500 MB',
  prizesData100MB:'ဒေတာ 100 MB',
  prizesData50MB:'ဒေတာ 50 MB',
  prizesData3GB:'ဒေတာ 3 GB',
  prizesData1GB:'ဒေတာ 1 GB',
  profileDefaultName:'ကစားသမား',
  profileSelectLanguage:'ဘာသာစကား',
  profileEnglish:'အင်္ဂလိပ်',
  profileMyanmar:'မြန်မာ',
  profileSelected:'ရွေးချယ်ထားသည်',
  profileConfirmTitle:'ပယ်ဖျက်မှု အတည်ပြုပါ',
  profileEditName:'အမည်ပြောင် ပြင်ဆင်ရန်',
  profileNamePlaceholder:'အမည်ပြောင် ထည့်ပါ',
  profileNameRequired:'အမည်ပြောင် ထည့်ပါ။',
  profileCancel:'မလုပ်ပါ',
  claimRewardNetworkError:'ဒေတာလက်ဆောင်ကို ရယူ၍မရပါ။ ထပ်မံကြိုးစားပါ။',
  answerCorrectTitle:'မှန်ပါသည်!',
  answerWrongTitle:'မှားပါသည်!',
  answerYourAnswerIs:'သင့်အဖြေသည်',
  answerCorrectWord:'မှန်ပါသည်!',
  answerWrongWord:'မှားပါသည်!',
  answerYouGot:'သင်သည် ကံစမ်းသေတ္တာ',
  answerLuckyBoxes:'လုံး ရရှိပါသည်။',
  answerConfirmCorrect:'အရမ်းကောင်းတယ်!',
  answerConfirmWrong:'အိုကေ',
  answerClose:'အဖြေရလဒ်ကို ပိတ်ရန်',
  prizeOpenBoxTitle:'သေတ္တာဖွင့်ပါ',
  prizeOpenedPrefix:'သင်',
  prizeLuckyBox:'ကံစမ်းသေတ္တာတစ်လုံးကို ဖွင့်ပြီးပါပြီ!',
  prizeReceived:'အောက်ပါဆုလက်ဆောင်ကို ရရှိခဲ့ပါသည်။',
  prizeThankYou:'ကျေးဇူးတင်ပါသည်',
  prizeOk:'အိုကေ',
  prizeClaimReward:'ဆုလက်ဆောင် ရယူရန်',
  prizeClose:'ဆုရလဒ်ကို ပိတ်ရန်',
  winnerEmpty:'ဆုရရှိသူ မရှိသေးပါ',
  buyPopupTitle:'မေးခွန်းဝယ်ရန်',
  buyPopupNeedMore:'မေးခွန်းများ ထပ်လိုပါသလား။',
  buyPopupGet:'နောက်ထပ်',
  buyPopupExtraQuestions:'မေးခွန်းများ',
  buyPopupAnd:'ရယူပြီး',
  buyPopupKeepFun:'ပျော်ရွှင်စွာ ဆက်ကစားပါ။',
  buyPopupPrice:'မေးခွန်း ၁ ခု - ၉၉ ကျပ်',
  buyPopupClose:'မေးခွန်းဝယ်ယူမှုကို ပိတ်ရန်',
  buyOtpTitle:'တစ်ခါသုံးကုဒ် ထည့်ရန်',
  buyOtpPleaseEnter:'ကျေးဇူးပြု၍',
  buyOtpCode:'OTP',
  buyOtpCodeSuffix:'ကုဒ်ကို',
  buyOtpContinue:'ထည့်သွင်းပြီး ဆက်လက်လုပ်ဆောင်ပါ။',
  buyOtpConfirm:'အတည်ပြုရန်',
  helpFaqSection:'မေးလေ့ရှိသော မေးခွန်းများ',
  helpTermsSection:'စည်းမျဉ်းစည်းကမ်းများ',
  subscribeDailyPrice:'249 Ks',
  subscribeThreeDayPrice:'699 Ks',
  subscribeMonthlyPrice:'1999 Ks',
}




// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js